module.exports = __webpack_public_path__ + "img/serifnew_box26.3f8ed29d.jpg";